import * as React from "react";

export const SvgMessage = ({ color, ...props }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
		<path
			fill={color || "#A8A8A8"}
			stroke={color || "#A8A8A8"}
			strokeWidth={0.4}
			d="M5.733 17.933A.534.534 0 0 1 5.2 17.4v-2.667H3.6c-.882 0-1.6-.718-1.6-1.6V4.6C2 3.718 2.718 3 3.6 3h12.8c.882 0 1.6.718 1.6 1.6v8.533c0 .883-.718 1.6-1.6 1.6H9.92l-3.853 3.084a.532.532 0 0 1-.334.116ZM3.6 4.067a.534.534 0 0 0-.533.533v8.533c0 .294.239.534.533.534h2.133c.295 0 .534.238.534.533v2.09L9.4 13.785a.533.533 0 0 1 .333-.117H16.4c.294 0 .533-.24.533-.534V4.6a.534.534 0 0 0-.533-.533H3.6Z"
		/>
		<path
			fill={color || "#A8A8A8"}
			stroke={color || "#A8A8A8"}
			strokeWidth={0.4}
			d="M14.267 8.067H5.734a.533.533 0 1 1 0-1.067h8.533a.533.533 0 1 1 0 1.067ZM10 10.467H5.734a.533.533 0 1 1 0-1.067H10a.533.533 0 1 1 0 1.067Z"
		/>
	</svg>
);
